/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import Stack from '@mui/material/Stack';
import { EmbersSkeleton } from '../skeleton/skeleton';
import { StyledSkeleton, ROOT_PREFIX_LOADING } from './appSwitcherStyles';
export var AppSwitcherSkeleton = function AppSwitcherSkeleton() {
  return /*#__PURE__*/React.createElement(StyledSkeleton, {
    spacing: 4.5,
    className: ROOT_PREFIX_LOADING
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 2.5
  }, /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: 16,
    height: 16,
    animation: false
  }), /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: "calc(100% - 36px)",
    height: 16,
    animation: "progress"
  })), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 2.5
  }, /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: 16,
    height: 16,
    animation: false
  }), /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: "calc(100% - 36px)",
    height: 16,
    animation: "progress"
  })), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 2.5
  }, /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: 16,
    height: 16,
    animation: false
  }), /*#__PURE__*/React.createElement(EmbersSkeleton, {
    variant: "rectangular",
    width: "calc(100% - 36px)",
    height: 16,
    animation: "progress"
  })));
};